/**
 * Application version info
 */

export const VERSION_INFO = {
  version: import.meta.env.VITE_APP_VERSION ?? '0.0.0',
  gitHash: import.meta.env.VITE_GIT_HASH ?? 'unknown',
  gitBranch: import.meta.env.VITE_GIT_BRANCH ?? 'unknown',
  buildTime: import.meta.env.VITE_BUILD_TIME ?? new Date().toISOString(),
};

export function getVersionString(): string {
  const hash = VERSION_INFO.gitHash.slice(0, 7);
  return `v${VERSION_INFO.version} (${hash})`;
}

export function logVersionInfo(): void {
  const buildDate = new Date(VERSION_INFO.buildTime);
  const formattedDate = buildDate.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  console.log(
    `%c Code v${VERSION_INFO.version} %c ${VERSION_INFO.gitHash.slice(0, 7)} @ ${VERSION_INFO.gitBranch} %c Built: ${formattedDate} `,
    'background: #6366f1; color: white; padding: 6px; border-radius: 3px 0 0 0;',
    'background: #1e1b4b; color: #c7d2fe; padding: 6px;',
    'background: #0244df; color: #ffffff; padding: 6px; border-radius: 0 3px 3px 0;'
  );
}
